import { Box, Center, Collapse, Group, Loader, Text } from '@mantine/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBot, getMetricsMessageDetail, MetricsMessageDetailItem, MetricsMessageItem } from '@mygpt/app';
import QuestionItem from '@/components/Settings/MessageUsageModal/QuestionItem';

interface Props {
  item: MetricsMessageItem;
}

const QuotaItem: React.FC<Props> = ({ item }) => {
  const { t } = useTranslation();
  const { botId } = useBot();

  const [list, setList] = useState<MetricsMessageDetailItem[]>([]);
  const [listLoading, setListLoading] = useState(true);
  const [opened, setOpened] = useState(false);

  const getList = () => {
    getMetricsMessageDetail({ robot_id: botId, day: item.day })
      .then((res) => {
        setList(res.data);
      })
      .finally(() => {
        setListLoading(false);
      });
  };

  const detail = () => {
    setOpened((state) => !state);
    getList();
  };

  return (
    <Box className="border border-solid border-gray-200 rounded-md hover:border-violet-400">
      <Group justify="space-between" className="py-4 px-8 cursor-pointer" onClick={detail}>
        <Group gap={8}>
          <Text lh={1} size={'md'}>
            {item.day}
          </Text>
          <span className="w-1 h-1 bg-gray-500 rounded-full" />
          <Text lh={1} size="sm" color="gray.4">
            {t('settings.quota.modal.questions_number', { count: item.count })}
          </Text>
        </Group>
        <Group className="text-gray-500 text-sm">
          <Text lh={1} size={'12'} color="gray.4">
            {t('settings.quota.modal.message_quota')}
          </Text>
          <Text lh={1} size={'md'} color="gray.8">
            - {item.consumed}
          </Text>
        </Group>
      </Group>

      <Collapse in={opened}>
        <Box px={20} py={20} style={{ borderTopWidth: 1 }}>
          {listLoading && (
            <Center mih={100}>
              <Loader size={'sm'} />
            </Center>
          )}

          <ul className="space-y-4">
            {list.map((item, index) => {
              return (
                <li key={index}>
                  <QuestionItem item={item} />
                </li>
              );
            })}
          </ul>
        </Box>
      </Collapse>
    </Box>
  );
};

export default QuotaItem;
